export default {
  CashierService: {
    is: 'Gjaldkeraþjónusta',
    en: 'Cashier service',
  },
  CorporateBankingService: {
    is: 'Fyrirtækjaþjónusta',
    en: 'Corporate banking service',
  },
  FinanceConsultation: {
    is: 'Fjármálaráðgjöf',
    en: 'Finance consultation',
  },
  MailDelivery: {
    is: 'Póstafgreiðsla',
  },
  RetailBankingService: {
    is: 'Einstaklingsþjónusta',
    en: 'Retail bankings service',
  },
  ServiceVisit: {
    is: 'Þjónustuheimsóknir',
    en: 'Service visit',
  },

  Atm: {
    is: 'Hraðbanki',
    en: 'Atm',
  },
  CurrencyAtm: {
    is: 'Gjaldeyrir',
    en: 'Currency',
  },
  DepositAtm: {
    is: 'Innlögn',
    en: 'Deposit',
  },
  CoinRollAtm: {
    is: 'Myntrúllusjálfsali',
    en: 'Coin roll dispenser',
  },
  CoinCounterAtm: {
    is: 'Mynttalningarvél',
    en: 'Coin count machine',
  },
  GiftCardAtm: {
    is: 'Gjafakortasjálfsali',
    en: 'Gift card',
  },
  CorporateDepositAtm: {
    is: 'Fyrirtækjainnlegg',
    en: 'Corporate deposit',
  },

  atmsServices: {
    is: 'Hraðbankar og sjálfsafgreiðsla',
    en: 'ATMs',
  },
};
